(function () {
  // Mobile drawer
  var drawer = document.querySelector('[data-drawer]');
  var openBtn = document.querySelector('[data-menu-open]');
  var closeBtn = document.querySelector('[data-menu-close]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.style.overflow = open ? 'hidden' : '';
  }
  if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
  if (closeBtn) closeBtn.addEventListener('click', function () { setDrawer(false); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });

  // Header: transparent over the homepage hero, solid once you scroll
  var header = document.querySelector('[data-header]');
  if (header && document.querySelector('.hero--first')) {
    var setTransparent = function () { header.classList.toggle('is-transparent', window.scrollY < 40); };
    setTransparent();
    window.addEventListener('scroll', setTransparent, { passive: true });
  }

  // Hero slideshow
  function initHero(hero) {
    if (!hero || hero.getAttribute('data-ready')) return;
    hero.setAttribute('data-ready', '1');
    var slides = [].slice.call(hero.querySelectorAll('.hero-slide'));
    var dots = [].slice.call(hero.querySelectorAll('.hero-dot'));
    if (slides.length < 2) return;
    var current = 0;
    var timer = null;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var auto = hero.getAttribute('data-autoplay') === 'true' && !reduce;
    var ms = (parseInt(hero.getAttribute('data-interval'), 10) || 6) * 1000;
    function go(n) {
      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }
    function stop() { clearInterval(timer); timer = null; }
    function start() {
      stop();
      if (auto) timer = setInterval(function () { go(current + 1); }, ms);
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { go(n); start(); }); });
    hero.addEventListener('mouseenter', stop);
    hero.addEventListener('mouseleave', start);
    document.addEventListener('visibilitychange', function () { if (document.hidden) { stop(); } else { start(); } });
    start();
  }
  initHero(document.querySelector('[data-hero]'));

  // Reveal on scroll
  var reveals = [].slice.call(document.querySelectorAll('[data-reveal]'));
  if (reveals.length) {
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
      reveals.forEach(function (el) { io.observe(el); });
    } else {
      reveals.forEach(function (el) { el.classList.add('in'); });
    }
  }

  // Theme editor: show sections as they are added or edited
  document.addEventListener('shopify:section:load', function (e) {
    [].forEach.call(e.target.querySelectorAll('[data-reveal]'), function (el) { el.classList.add('in'); });
    initHero(e.target.querySelector('[data-hero]'));
  });

  // Product form: variant selection + ajax add to cart
  var wrap = document.querySelector('[data-product-form-wrap]');
  if (!wrap) return;
  var form = wrap.querySelector('[data-product-form]');
  var json = wrap.querySelector('[data-variants]');
  if (!form || !json) return;
  var variants = JSON.parse(json.textContent);
  var idInput = form.querySelector('[data-variant-id]');
  var addBtn = form.querySelector('[data-add]');
  var note = form.querySelector('[data-note]');
  var priceEl = wrap.querySelector('[data-price]');

  function selected() {
    var fields = form.querySelectorAll('.opt');
    var vals = [];
    fields.forEach(function (f) {
      var c = f.querySelector('input:checked');
      vals.push(c ? c.value : null);
    });
    return vals;
  }
  function findVariant(vals) {
    if (!vals.length) return variants[0];
    return variants.find(function (v) {
      return vals.every(function (val, i) { return val === null || v.options[i] === val; });
    });
  }
  function fmt(cents) {
    var n = cents / 100;
    var s = n % 1 === 0 ? n.toFixed(0) : n.toFixed(2);
    return '€' + s;
  }
  function update() {
    var v = findVariant(selected());
    if (!v) {
      addBtn.disabled = true;
      addBtn.textContent = 'Unavailable';
      return;
    }
    idInput.value = v.id;
    if (priceEl) priceEl.textContent = fmt(v.price);
    addBtn.disabled = !v.available;
    addBtn.textContent = v.available ? 'Add to bag' : 'Sold out';
    var url = new URL(window.location.href);
    url.searchParams.set('variant', v.id);
    window.history.replaceState({}, '', url);
  }
  form.addEventListener('change', update);

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (addBtn.disabled) return;
    addBtn.disabled = true;
    note.textContent = '';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: idInput.value, quantity: 1 })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
      .then(function (res) {
        if (!res.ok) { note.textContent = res.d.description || 'Could not add.'; return; }
        note.textContent = 'Added to bag.';
        return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
          document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = c.item_count; });
        });
      })
      .catch(function () { note.textContent = 'Something went wrong.'; })
      .then(function () { addBtn.disabled = false; });
  });
})();
